import {ListItem} from '../list/list_item.tsx';
import {Icon} from '../icon/icon.tsx';
import listStyles from '../list/list.module.scss';
import {LocationType} from '../../gql/customer/graphql.ts';
import {Spacer} from '../utility/spacer.tsx';

interface OwnProps {
    location: LocationType | null;
    onClick: (location: (LocationType | null) | null) => void;
}
export function LocationListItem({location, onClick}: OwnProps) {
    if (!location) {
        return null;
    }
    return (
        <ListItem onClick={() => onClick(location)}>
            <div className={listStyles.list__item_content}>
                <Icon src={location.photo_url ?? ''} />
                <Spacer />
                <span>{location.name}</span>
            </div>
        </ListItem>
    );
}
